import React from "react";
import ReactPlayer from "react-player/youtube";
import { PlayIcon } from "../../Molecules/icons";
import { MarkupText } from "./MarkupText";
export function ParagraphVideos(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "paragraph-container container-page flex flex-col md:flex-row gap-8 md:gap-5"
    }, !!props.left && /*#__PURE__*/ React.createElement("section", {
        className: "flex flex-col gap-6 pb-6 w-full md:w-1/2"
    }, /*#__PURE__*/ React.createElement(VideoWithThumbNail, props.left), /*#__PURE__*/ React.createElement("h3", {
        className: "text-green-500 m-0"
    }, props.left.title), props.left.description && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.left.description
    }))), !!props.right && /*#__PURE__*/ React.createElement("section", {
        className: "flex flex-col gap-6 pb-6 w-full md:w-1/2 items-stretch"
    }, /*#__PURE__*/ React.createElement(VideoWithThumbNail, props.right), /*#__PURE__*/ React.createElement("h3", {
        className: "text-green-500 m-0"
    }, props.right.title), props.right.description && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.right.description
    }))));
}
var VideoWithThumbNail = function(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative pt-[56.25%]"
    }, /*#__PURE__*/ React.createElement(ReactPlayer, {
        className: "absolute top-0 left-0",
        width: "100%",
        height: "100%",
        playing: true,
        controls: true,
        //TODO get higher resolution thubnail
        light: props.videoHasMaxResThumbnail ? "https://img.youtube.com/vi/".concat(props.videoId, "/maxresdefault.jpg") : true,
        url: props.video,
        playIcon: /*#__PURE__*/ React.createElement(PlayIcon, null)
    }));
};
